import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import {Grid} from "@mui/material";
import {RootState, useAppSelector} from "../../../store";
import React from "react";
import {getRandomWhyGenieArray} from "../../../store/home/Helper";
import WhyGenieGridItem from "./why-genie-grid-item/WhyGenieGridItem";

const WhyGenie = () => {
    const {t} = useTranslation()
    const homeWhyGenie = useAppSelector((state: RootState) => state.homeReducer.content.why_genie)
    const loading = useAppSelector((state: RootState) => state.homeReducer.loading)

    return (
        <Box mt={8}>
            <Typography variant="h4" color="primary" fontWeight={600}>
                {t('why_genie')}
            </Typography>
            <Grid container spacing={4} justifyContent='space-evenly' mt={0}>
                {(loading ? getRandomWhyGenieArray() : homeWhyGenie).map((wg) => (
                    <WhyGenieGridItem loading={loading} item={wg} key={wg.title_en}/>
                ))}
            </Grid>
        </Box>
    )
}

export default WhyGenie
